export default "__VITE_ASSET__DT_u9GEs__"